/* OrbisHabita — scripts propios */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.oh-reveal:not(.oh-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('oh-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('oh-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-oh-cifra]:not([data-oh-hecho])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-oh-hecho', '1');
      var fin = parseFloat(el.getAttribute('data-oh-cifra')) || 0;
      var dec = (el.getAttribute('data-oh-cifra').split('.')[1] || '').length;
      var suf = el.getAttribute('data-oh-sufijo') || '';
      if (reduce) { el.textContent = fin.toFixed(dec) + suf; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMaterial() {
    document.querySelectorAll('[data-oh-material]').forEach(function (sec) {
      if (sec.getAttribute('data-oh-listo')) return;
      sec.setAttribute('data-oh-listo', '1');
      var pasos = sec.querySelectorAll('.oh-material__paso');
      var imgs = sec.querySelectorAll('.oh-material__media img');
      if (!pasos.length) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('oh-activo', j === i); });
        if (imgs.length) imgs.forEach(function (im, j) { im.classList.toggle('oh-activa', j === Math.min(i, imgs.length - 1)); });
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  function formatoDinero(cents, formato) {
    var v = (cents / 100).toFixed(2);
    var partes = v.split('.');
    var conComa = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1];
    var conPunto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
    if (!formato) return conComa + ' €';
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, tipo) {
      if (tipo === 'amount') return conPunto;
      if (tipo === 'amount_no_decimals') return partes[0];
      if (tipo === 'amount_no_decimals_with_comma_separator') return partes[0];
      return conComa;
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-oh-producto]').forEach(function (root) {
      if (root.getAttribute('data-oh-listo')) return;
      root.setAttribute('data-oh-listo', '1');

      // Galería
      var principal = root.querySelector('.oh-galeria__principal img');
      var minis = root.querySelectorAll('.oh-galeria__mini');
      function mostrar(mini) {
        if (!principal || !mini) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = mini.getAttribute('data-oh-src');
          principal.alt = mini.getAttribute('data-oh-alt') || '';
          principal.style.opacity = '1';
        }, 150);
        minis.forEach(function (m) { m.classList.toggle('oh-activa', m === mini); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      // Cantidad
      var cant = root.querySelector('.oh-cantidad input');
      root.querySelectorAll('[data-oh-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v += parseInt(b.getAttribute('data-oh-cant'), 10);
          cant.value = Math.max(1, v);
        });
      });

      // Variantes
      var datos = root.querySelector('[data-oh-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = root.getAttribute('data-oh-formato');
      var inputId = root.querySelector('input[name="id"]');
      var precio = root.querySelector('.oh-compra__precio-actual');
      var antes = root.querySelector('.oh-compra__precio-antes');
      var ahorro = root.querySelector('.oh-compra__ahorro');
      var boton = root.querySelector('.oh-compra__boton');
      var textoBoton = boton ? boton.getAttribute('data-oh-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-oh-agotado') : '';

      function actualizar() {
        var sel = [];
        root.querySelectorAll('.oh-opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
          return;
        }
        inputId.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = formatoDinero(v.compare_at_price, formato);
            antes.hidden = false;
            if (ahorro) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else {
            antes.hidden = true;
            if (ahorro) ahorro.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_image) {
          var mini = root.querySelector('.oh-galeria__mini[data-oh-id="' + v.featured_image.id + '"]');
          if (mini) mostrar(mini);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      root.querySelectorAll('.oh-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  function initTodo() { initReveal(); initCifras(); initMaterial(); initProducto(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
